import { render, staticRenderFns } from "./server-file-sync.vue?vue&type=template&id=07837ad6&"
import script from "./server-file-sync.vue?vue&type=script&lang=js&"
export * from "./server-file-sync.vue?vue&type=script&lang=js&"
import style0 from "./server-file-sync.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports